import React, {Component, Fragment} from 'react';
import {observer} from 'mobx-react';

import Header from 'lib/struct/headers/Header';
import Status from 'lib/struct/Status';
import Field from 'lib/struct/form/fields/Field';
import ColorPicker from 'lib/struct/form/ColorPicker';
import InputText from 'lib/struct/form/InputText';
import Checkbox from 'lib/struct/form/Checkbox';

@observer export default class MarkupStyleSettingsForm extends Component {
	render() {
		/** @type {SettingsContext} */
		const context = this.props.context;

		if (
			!context.settings.markup_style_theme_storefront_settings.has(context.current_style_theme_id)
			|| !context.settings.markup_style_theme_storefront_settings.get(context.current_style_theme_id).has(context.current_style_storefront)
		) {
			return (
				<div>
					<Status status={context.markup_template_loading_state}/>
				</div>
			);
		}

		const settings = context.current_markup_style_settings;
		if (!settings) {
			return null;
		}

		return (
			<div>
				<Field label="Ограничить высоту блока группы">
					<Checkbox
						checked={settings.hide_group_items}
						onChange={e => context.updateCurrentMarkupStyleSettingsValue('hide_group_items', e.target.checked)}
					/>
				</Field>
				{
					settings.hide_group_items ? (
						<Field label='Количество отображаемых строк в блоке'>
							<InputText
								value={settings.row_limit}
								onChange={e => context.updateCurrentMarkupStyleSettingsValue('row_limit', e.target.value)}
								placeholder='3'
							/>
						</Field>
					): (null)
				}
				<Field label="Подключить CSS-стили плагина">
					<Checkbox
						checked={settings.is_plugin_css_used}
						onChange={e => context.updateCurrentMarkupStyleSettingsValue('is_plugin_css_used', e.target.checked)}
					/>
				</Field>

				{
					settings.is_plugin_css_used ? (
						<Fragment>
							<Header>Блок</Header>
							<Field label='Размер текста заголовка группы'>
								<InputText
									value={settings.groups_header_font_size}
									onChange={e => context.updateCurrentMarkupStyleSettingsValue('groups_header_font_size', e.target.value)}
									placeholder='14px'
								/>
							</Field>

							<Header>Список</Header>
							<Field label='Цвет текста'>
								<ColorPicker
									value={settings.simple_group_font_color}
									onChangeColor={value => context.updateCurrentMarkupStyleSettingsValue('simple_group_font_color', value)}
									placeholder='#808080'
								/>
							</Field>
							<Field label='Цвет фона'>
								<ColorPicker
									value={settings.simple_group_background_color}
									onChangeColor={value => context.updateCurrentMarkupStyleSettingsValue('simple_group_background_color', value)}
									placeholder='#ffffff'
								/>
							</Field>
							<Field label='Цвет рамки'>
								<ColorPicker
									value={settings.simple_group_border_color}
									onChangeColor={value => context.updateCurrentMarkupStyleSettingsValue('simple_group_border_color', value)}
									placeholder='#e5e5e5'
								/>
							</Field>
							<Field label='Толщина рамки'>
								<InputText
									value={settings.simple_group_border_width}
									onChange={e => context.updateCurrentMarkupStyleSettingsValue('simple_group_border_width', e.target.value)}
									placeholder='2px'
								/>
							</Field>
							<Field label='Цвет рамки активного товара'>
								<ColorPicker
									value={settings.simple_group_active_border_color}
									onChangeColor={value => context.updateCurrentMarkupStyleSettingsValue('simple_group_active_border_color', value)}
									placeholder='#f2994a'
								/>
							</Field>
							<Field label='Цвет рамки при наведении'>
								<ColorPicker
									value={settings.simple_group_border_hover_color}
									onChangeColor={value => context.updateCurrentMarkupStyleSettingsValue('simple_group_border_hover_color', value)}
									placeholder='#f2994a'
								/>
							</Field>

							<Header>Фото</Header>
							<Field label='Высота'>
								<InputText
									value={settings.photo_group_item_height}
									onChange={e => context.updateCurrentMarkupStyleSettingsValue('photo_group_item_height', e.target.value)}
									placeholder='60px'
								/>
							</Field>
							<Field label='Ширина'>
								<InputText
									value={settings.photo_group_item_width}
									onChange={e => context.updateCurrentMarkupStyleSettingsValue('photo_group_item_width', e.target.value)}
									placeholder='60px'
								/>
							</Field>
							<Field label='Цвет рамки'>
								<ColorPicker
									value={settings.photo_group_border_color}
									onChangeColor={value => context.updateCurrentMarkupStyleSettingsValue('photo_group_border_color', value)}
									placeholder='#e5e5e5'
								/>
							</Field>
							<Field label='Цвет рамки активного товара'>
								<ColorPicker
									value={settings.photo_group_active_border_color}
									onChangeColor={value => context.updateCurrentMarkupStyleSettingsValue('photo_group_active_border_color', value)}
									placeholder='#f2994a'
								/>
							</Field>
							<Field label='Закругление'>
								<InputText
									value={settings.photo_group_border_radius}
									onChange={e => context.updateCurrentMarkupStyleSettingsValue('photo_group_border_radius', e.target.value)}
									placeholder='5px'
								/>
							</Field>

							<Header>Цвет</Header>
							<Field label='Цвет рамки'>
								<ColorPicker
									value={settings.color_group_border_color}
									onChangeColor={value => context.updateCurrentMarkupStyleSettingsValue('color_group_border_color', value)}
									placeholder='#e5e5e5'
								/>
							</Field>
							<Field label='Цвет рамки при наведении'>
								<ColorPicker
									value={settings.color_group_border_hover_color}
									onChangeColor={value => context.updateCurrentMarkupStyleSettingsValue('color_group_border_hover_color', value)}
									placeholder='#f2994a'
								/>
							</Field>
							<Field label='Толщина рамки'>
								<InputText
									value={settings.color_group_border_width}
									onChange={e => context.updateCurrentMarkupStyleSettingsValue('color_group_border_width', e.target.value)}
									placeholder='2px'
								/>
							</Field>
							<Field label='Цвет рамки активного товара'>
								<ColorPicker
									value={settings.color_group_active_border_color}
									onChangeColor={value => context.updateCurrentMarkupStyleSettingsValue('color_group_active_border_color', value)}
									placeholder='#f2994a'
								/>
							</Field>
							<Field label='Закругление'>
								<InputText
									value={settings.color_group_border_radius}
									onChange={e => context.updateCurrentMarkupStyleSettingsValue('color_group_border_radius', e.target.value)}
									placeholder='50%'
								/>
							</Field>
						</Fragment>
					) : (null)
				}
			</div>
		);
	}
}